module.exports = __webpack_public_path__ + "static/media/ice03.17befbaf.webp";